import { put, call, all, select, takeLatest } from 'redux-saga/effects';
import {
  create as createContract,
  fetchFiltered as fetchFilteredContract,
  cancel as cancelContract
} from './insuranceContracts/sagas';
import * as contractActions from './insuranceContracts/actions';
import { create as createDevice,
         activate as activateDevice,
         fetchFiltered as fetchFilteredDevice,
         cancel as cancelDevice,
      } from './insuredDevices/sagas';
import * as deviceActions from './insuredDevices/actions';
import { getAll as fetchPurchases } from 'billing/purchases/sagas';
import * as purchaseActions from 'billing/purchases/actions';
import { find as findSprintSubscription } from 'subscriptions/sprint/sagas';
import { find as findBypassedSubscription } from 'subscriptions/bypassed/sagas';
import { find as findQuickSubscription } from 'subscriptions/quick/sagas';
import * as sprintActions from 'subscriptions/sprint/actions';
import * as bypassedActions from 'subscriptions/bypassed/actions';
import * as quickActions from 'subscriptions/quick/actions';
import * as types from './types';
import * as routes from 'app/routes';
import * as selectors from 'reducers';
import { formatDateUtc } from 'helpers/formatters';
import { error } from 'notifications/actions';

export function* createSprintPurchase({ payload }) {
  const { subId, sku, planType } = payload;
  let deviceId, contractId, purchaseId;
  try {
    // If contact and device status - pending
    // cancel them before creating new
    yield call(fetchFilteredContract, contractActions.fetchFiltered({ subscription: subId, status: 'pending' }) );
    const contracts = yield select(selectors.getFilteredInsuranceContracts, { subscription: subId });
    const pendingContract = contracts.find(contract => contract.status === 'pending');

    if (pendingContract) {
      yield call(cancelContract, contractActions.cancel(pendingContract.id));
    }

    yield call(findSprintSubscription, sprintActions.find(subId));
    yield call(createContract, contractActions.create({ subscription: subId }));
    contractId = yield select(selectors.getSprintInsuranceContractId, subId);
       
    if (!contractId) {
      const errorMessage = yield select(selectors.getInsuranceContractCreateError);
      throw new Error(errorMessage);
    }


    yield call(createDevice, deviceActions.create({
      contract: contractId,
      device_specs: sku,
      plan_type: planType,
      condition: 'byod',
      purchase_date: formatDateUtc(new Date(), 'YYYY-MM-DD'),
      is_replacement: false
    }));
    deviceId = yield select(selectors.getInsuredDeviceId, contractId);

    if (!deviceId) {
      const errorMessage = yield select(selectors.getInsuredDeviceCreateError);
      throw new Error(errorMessage);
    }

    console.log('selected deviceId');
    yield call(activateDevice, deviceActions.activate(deviceId));

    const activationError = yield select(selectors.getInsuredDeviceActivationError)
    if (activationError) {
      throw new Error(activationError)
    }

    const purchase = yield select(selectors.getInsuredDevicePurchase, deviceId);
    console.log('selected purchase', purchase);

    if (!purchase) {
      const purchaseError = yield select(selectors.getGetAllPurchasesError);
      throw new Error(purchaseError);
    }

    if (contractId && deviceId && purchase) {
      yield put(routes.insurancePurchase(purchase.id, contractId));
    }
    else {
      throw new Error();
    }
  }
  catch (err) {
    if (contractId && deviceId) {
      yield call(cancelDevice, deviceActions.cancel(deviceId, { cancel_contract: true }));
    } else if (contractId && !deviceId) {
      yield call(cancelContract, contractActions.cancel(contractId));
    }
    yield put(error('confirmInsurance',  err.message && err.message !== 'Server Error' ? err.message : 'There was an error, please contact Wing for assistance.'));
  }
}
export function* createBypassedPurchase({ payload }) {
  const { subId, sku, planType } = payload;
  const phoneDeviceId = payload.deviceId;
  let deviceId, contractId, purchaseId;
  try {
    // If contact and device status - pending
    // cancel them before creating new
    yield call(fetchFilteredContract, contractActions.fetchFiltered({ bypassed_subscription: subId, status: 'pending' }) );
    const contracts = yield select(selectors.getFilteredInsuranceContracts, { bypassedSubscription: subId });
    const pendingContract = contracts.find(contract => contract.status === 'pending');

    if (pendingContract) {
      yield call(cancelContract, contractActions.cancel(pendingContract.id));
    }
    
    yield call(findBypassedSubscription, bypassedActions.find(subId));
    yield call(createContract, contractActions.create({ bypassed_subscription: subId, device_id: phoneDeviceId }));
    contractId = yield select(selectors.getBypassedInsuranceContractId, subId);
   
    if (!contractId) {
      const errorMessage = yield select(selectors.getInsuranceContractCreateError);
      throw new Error(errorMessage);
    }

    yield call(createDevice, deviceActions.create({
      contract: contractId,
      device_specs: sku,
      plan_type: planType,
      condition: 'byod',
      purchase_date: formatDateUtc(new Date(), 'YYYY-MM-DD'),
      is_replacement: false
    }));
    deviceId = yield select(selectors.getInsuredDeviceId, contractId);

    if (!deviceId) {
      const errorMessage = yield select(selectors.getInsuredDeviceCreateError);
      throw new Error(errorMessage);
    }

    console.log('selected deviceId');
    yield call(activateDevice, deviceActions.activate(deviceId));

    const activationError = yield select(selectors.getInsuredDeviceActivationError)
    if (activationError) {
      throw new Error(activationError)
    }

    const purchase = yield select(selectors.getInsuredDevicePurchase, deviceId);
    console.log('selected purchase', purchase);

    if (!purchase) {
      const purchaseError = yield select(selectors.getGetAllPurchasesError);
      throw new Error(purchaseError);
    }

    if (contractId && deviceId && purchase) {
      yield put(routes.insurancePurchase(purchase.id, contractId));
    }
    else {
      throw new Error();
    }
  }
  catch (err) {
    if (contractId && deviceId) {
      yield call(cancelDevice, deviceActions.cancel(deviceId, { cancel_contract: true }));
    } else if (contractId && !deviceId) {
      yield call(cancelContract, contractActions.cancel(contractId));
    }
    yield put(error('confirmInsurance',  err.message && err.message !== 'Server Error' ? err.message : 'There was an error, please contact Wing for assistance.'));
  }
}

export function* createQuickPurchase({ payload }) {
  const { subId, sku, planType } = payload;
  const phoneDeviceId = payload.deviceId;
  let deviceId, contractId, purchaseId;
  try {
    // If contact and device status - pending
    // cancel them before creating new
    yield call(fetchFilteredContract, contractActions.fetchFiltered({ quick_subscription: subId, status: 'pending' }) );
    const contracts = yield select(selectors.getFilteredInsuranceContracts, { quickSubscription: subId });
    const pendingContract = contracts.find(contract => contract.status === 'pending');

    if (pendingContract) {
      yield call(cancelContract, contractActions.cancel(pendingContract.id));
    }
    
    yield call(findQuickSubscription, quickActions.find(subId));
    yield call(createContract, contractActions.create({ quick_subscription: subId, device_id: phoneDeviceId }));
    contractId = yield select(selectors.getQuickInsuranceContractId, subId);
   
    if (!contractId) {
      const errorMessage = yield select(selectors.getInsuranceContractCreateError);
      throw new Error(errorMessage);
    }

    yield call(createDevice, deviceActions.create({
      contract: contractId,
      device_specs: sku,
      plan_type: planType,
      condition: 'byod',
      purchase_date: formatDateUtc(new Date(), 'YYYY-MM-DD'),
      is_replacement: false
    }));
    deviceId = yield select(selectors.getInsuredDeviceId, contractId);

    if (!deviceId) {
      const errorMessage = yield select(selectors.getInsuredDeviceCreateError);
      throw new Error(errorMessage);
    }

    yield call(activateDevice, deviceActions.activate(deviceId));

    const activationError = yield select(selectors.getInsuredDeviceActivationError)
    if (activationError) {
      throw new Error(activationError)
    }

    const purchase = yield select(selectors.getInsuredDevicePurchase, deviceId);

    if (!purchase) {
      const purchaseError = yield select(selectors.getGetAllPurchasesError);
      throw new Error(purchaseError);
    }

    if (contractId && deviceId && purchase) {
      yield put(routes.insurancePurchase(purchase.id, contractId));
    }
    else {
      throw new Error();
    }
  }
  catch (err) {
    if (contractId && deviceId) {
      yield call(cancelDevice, deviceActions.cancel(deviceId, { cancel_contract: true }));
    } else if (contractId && !deviceId) {
      yield call(cancelContract, contractActions.cancel(contractId));
    }
    yield put(error('confirmInsurance',  err.message && err.message !== 'Server Error' ? err.message : 'There was an error, please contact Wing for assistance.'));
  }
}

export function* watchCreateSprintPurchase() {
  yield takeLatest(types.CREATE_SPRINT_PURCHASE, createSprintPurchase);
}

export function* watchcreateBypassedPurchase() {
  yield takeLatest(types.CREATE_BYPASSED_PURCHASE, createBypassedPurchase);
}

export function* watchCreateQuickPurchase() {
  yield takeLatest(types.CREATE_QUICK_PURCHASE, createQuickPurchase);
}

export function* watchInsurance() {
  yield all([
    call(watchCreateSprintPurchase),
    call(watchcreateBypassedPurchase),
    call(watchCreateQuickPurchase),
  ]);
}
